import * as React from "react"
import _ from 'lodash' 
import styled, { keyframes }  from "styled-components";

const AnimateDash = keyframes`
    to {
      stroke-dashoffset: 0;
    }
  `

const OuterCircle = styled.circle`
  fill: ${(props) => props.theme.highlightColor};
  stroke: ${(props) => props.theme.backgroundColor};
  stroke-width: 2px;
`

const StyledCircle = styled.circle`
  fill: none;
  stroke: ${(props) => props.theme.backgroundColor};
  stroke-width: 2px;
  stroke-dasharray: ${_.random(10,15)};
  stroke-dashoffset: 1000;
  animation: ${AnimateDash} 220s linear alternate infinite;
  animation-delay: 250ms;
`

const Radar = (props) => {
  return (
    <svg viewBox="0 0 100 100" {...props}>
      <OuterCircle cx="35" cy="70" r="19" />
      <StyledCircle cx="35" cy="70" r="15" />
      <StyledCircle cx="35" cy="70" r="10" />
      <StyledCircle cx="35" cy="70" r="3" />
    </svg>
  )
}

export default Radar
